import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';

interface LogoutModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div 
            className="fixed inset-0 z-[200] bg-black/80 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onCancel}
          />
          
          {/* Modal */}
          <motion.div 
            className="fixed inset-0 z-[201] flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div 
              className="tesla-card p-6 w-full max-w-md"
              initial={{ scale: 0.95, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.95, y: 20 }}
              transition={{ duration: 0.2 }}
            >
            {/* Icon */}
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-red-500/10 border border-red-500/20 rounded-full flex items-center justify-center">
                <AlertTriangle size={32} className="text-red-400" />
              </div>
            </div>

            {/* Title */}
            <h3 className="text-center text-xl font-bold text-white mb-3">
              Подтверждение выхода
            </h3>

            {/* Warning */}
            <div className="bg-red-500/5 border border-red-500/20 rounded-lg p-4 mb-6">
              <p className="text-center text-red-300 text-sm font-medium mb-2">
                ⚠️ ВАЖНОЕ ПРЕДУПРЕЖДЕНИЕ
              </p>
              <p className="text-center text-tesla-gray text-sm leading-relaxed">
                Создание мультиаккаунтов <span className="text-red-400 font-semibold">строго запрещено</span> и влечет за собой 
                <span className="text-red-400 font-semibold"> полную блокировку</span> всех связанных аккаунтов без возможности восстановления.
              </p>
            </div>

            {/* Message */}
            <p className="text-center text-tesla-gray text-sm mb-6">
              Вы уверены, что хотите выйти из партнерского аккаунта?
            </p>

            {/* Buttons */}
            <div className="flex space-x-3">
              <button
                onClick={onCancel}
                className="flex-1 tesla-button-secondary"
              >
                Отмена
              </button>
              <button
                onClick={onConfirm}
                className="flex-1 tesla-button"
              >
                Выйти
              </button>
            </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default LogoutModal; 